// Inline-formatting parser for text blocks.
//
// The backend converts assistant HTML (e.g. <strong>X</strong>) into
// markdown-style markers in the text value (`**X**`). This module splits
// a text block's value into a sequence of `{ text, bold? }` parts so
// MessageBlocks can render each part safely via `{{ }}` interpolation
// while wrapping bold parts in a styled span.
//
// SECURITY: each returned `text` field is a substring of the input
// (unchanged characters), still rendered through Vue's auto-escape.
// No HTML is constructed here; we only split on `**` boundaries.

const BOLD_PATTERN = /\*\*([\s\S]+?)\*\*/g;

export default function parseInline(value) {
  if (typeof value !== 'string') {
    return [{ text: '' }];
  }
  if (value === '') {
    return [{ text: '' }];
  }
  const parts = [];
  let lastIndex = 0;
  let match = BOLD_PATTERN.exec(value);
  while (match !== null) {
    if (match.index > lastIndex) {
      parts.push({ text: value.substring(lastIndex, match.index) });
    }
    parts.push({ text: match[1], bold: true });
    lastIndex = BOLD_PATTERN.lastIndex;
    match = BOLD_PATTERN.exec(value);
  }
  if (lastIndex < value.length) {
    parts.push({ text: value.substring(lastIndex) });
  }
  if (parts.length === 0) {
    parts.push({ text: value });
  }
  return parts;
}
